import { getDefaultAsoPricing, isAsoTemplate } from "./asoModel.js";
import { emptyProposalData } from "./emptyProposal.js";
import { emptyRenewal } from "./emptyRenewal.js";

const STORAGE_KEY = "centivo.commercial.proposals.v1";

export function createLevelFundedDraft() {
    const now = new Date().toISOString();
    return {
        id: crypto.randomUUID(),
        templateType: "level-funded",
        companyName: "",
        proposalDate: "",
        effectiveDate: "",
        acceptanceDeadline: "",
        planOfferingVariant: "partnership-cigna",
        includeAsoOption: false,
        includeTotalCostOfCareSavings: false,
        includeStandardPlansDisclosure: false,
        firmProposal: false,
        ratesTableVariant: "rates",
        sourceFileName: "",
        stopLossFileName: "",
        stopLossNote: "",
        stopLossContingencies: "",
        mapNotes: [],
        data: emptyProposalData(),
        updatedAt: now,
        createdAt: now,
    };
}

export function createRenewalDraft() {
    const now = new Date().toISOString();
    return {
        id: crypto.randomUUID(),
        templateType: "renewal",
        companyName: "",
        effectiveDate: "",
        renewal: emptyRenewal(),
        updatedAt: now,
        createdAt: now,
    };
}

export function createAsoDraft(templateType = "aso") {
    const type = isAsoTemplate(templateType) ? templateType : "aso";
    const now = new Date().toISOString();
    return {
        id: crypto.randomUUID(),
        templateType: type,
        companyName: "",
        proposalDate: "",
        asoOpeningSentence: "",
        asoProprietaryNetwork: "",
        asoProposedPbmName: "",
        asoPricing: getDefaultAsoPricing(type),
        planOfferingVariant: type === "aso" ? "partnership-cigna" : "partnership-only",
        includeIllustrativeAsoPremium: false,
        includeAsoEquivalents: false,
        includeAsoStopLossQuotes: false,
        asoWiSolutionVariant: "wi-both",
        asoWiEmployeeTerm: "employees",
        includeAsoWiNetworkAccess: true,
        includeAsoWiGeoAccess: true,
        includeAsoWiCigna: true,
        includeAsoWiCignaPbm: false,
        asoWiOtherGeographies: "",
        stopLossContingencies: "",
        stopLossFileName: "",
        stopLossNote: "",
        sourceFileName: "",
        mapNotes: [],
        data: emptyProposalData(),
        updatedAt: now,
        createdAt: now,
    };
}

function readAll() {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function listProposals() {
    return readAll().sort((a, b) => String(b.updatedAt).localeCompare(String(a.updatedAt)));
}

export function saveProposal(draft) {
    const next = { ...draft, updatedAt: new Date().toISOString() };
    const all = readAll();
    const index = all.findIndex((item) => item.id === next.id);
    if (index >= 0) all[index] = next;
    else all.push(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    return next;
}

export function deleteProposal(id) {
    const all = readAll().filter((item) => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}
